import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("my_tasks.visualization_access"))),
      ]),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.downloadMassive },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.download"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VCard,
        [
          _c(VDataTable, {
            staticClass: "table-inca",
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              expanded: _vm.expanded,
              "item-key": "report_id",
              "single-expand": "",
              "items-per-page": _vm.pagination.limit,
              page: _vm.pagination.current,
              "hide-default-footer": "",
            },
            on: {
              pagination: function ($event) {
                _vm.pagination.total = $event.itemsLength
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item.report",
                fn: function (data) {
                  return [
                    _c("span", { staticStyle: { "font-size": "12px" } }, [
                      _vm._v(_vm._s(data.item.object_name)),
                    ]),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function (data) {
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.clickedRow(data.item)
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-view")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("my_tasks.email_details"))),
                        ]),
                      ]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downloadData(data.item)
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-download")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("my_tasks.download_csv"))),
                        ]),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "expanded-item",
                fn: function (ref) {
                  var item = ref.item
                  var headers = ref.headers
                  return [
                    _c(
                      "td",
                      {
                        staticStyle: { padding: "0px !important" },
                        attrs: { colspan: headers.length },
                      },
                      [_c("user-access-details", { attrs: { record: item } })],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            id: _vm.modalUserAccessObject,
            title: "OBJECT PERMISSIONS",
            "hide-footer": "",
            size: "sm",
          },
        },
        [_c("user-access-objects", { attrs: { record: _vm.record } })],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            id: _vm.modalUserAccessNew,
            title: "ASSIGN NEW DP EMAIL",
            "hide-footer": "",
            size: "sm",
          },
        },
        [_c("user-access-new", { attrs: { record: _vm.record } })],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            id: _vm.modalUserAccessLogs,
            title: "LOGS",
            "hide-footer": "",
            size: "sm",
          },
        },
        [_c("user-access-logs", { attrs: { record: _vm.record } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }